mutation RequestVideoDownload($contentId: ID!) {
  requestVideoDownload(contentId: $contentId) {
    status
    percent
    url
    error
  }
}
